import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import { DateRender } from "@src/components/DateRender";
import { Experience } from "@src/store/slices/experiences/types";
import { dateTimeConverter } from "@src/utils/dateConverters";

import { calculateStatus } from "./utils";

interface AnalyticStatusChipProps {
  experience: Experience;
}

export const AnalyticStatusChip = ({ experience }: AnalyticStatusChipProps) => {
  const theme = useTheme();
  if (experience.status === "pending" || experience.status === "ended") {
    return <div />;
  } else if (experience.status === "paused") {
    return (
      <IgTypography color={theme.palette.text.secondary}>
        Paused on <DateRender date={dateTimeConverter(experience.pausedAtTs)} />
      </IgTypography>
    );
  } else {
    return (
      <IgTypography color={theme.palette.text.secondary}>
        {calculateStatus(experience).label}
      </IgTypography>
    );
  }
};
